module.exports = __webpack_public_path__ + "img/梁润辉.db4472eb.jpg";